/**
 * Generated from https://github.com/jive/com.jive.api.specifications/blob/master/specs/internal/messaging/v1/specs.yaml
 */
var SortMode;
(function (SortMode) {
    SortMode["FIRST_CREATED"] = "+creationDate";
    SortMode["LAST_CREATED"] = "-creationDate";
    SortMode["OLDEST_MESSAGE"] = "+lastMessageTimestamp";
    SortMode["NEWEST_MESSAGE"] = "-lastMessageTimestamp";
})(SortMode || (SortMode = {}));
var DeliveryStatusDescription;
(function (DeliveryStatusDescription) {
    DeliveryStatusDescription["INVALID_DESTINATION"] = "INVALID_DESTINATION";
    DeliveryStatusDescription["UNKNOWN_SERVER_ERROR"] = "UNKNOWN_SERVER_ERROR";
    DeliveryStatusDescription["DELIVERY_FAILURE"] = "DELIVERY_FAILURE";
    DeliveryStatusDescription["PROVISIONING_ISSUE"] = "PROVISIONING_ISSUE";
    DeliveryStatusDescription["REJECTED_BY_CARRIER"] = "REJECTED_BY_CARRIER";
    DeliveryStatusDescription["TEMPORARY_DELIVERY_FAILURE"] = "TEMPORARY_DELIVERY_FAILURE";
})(DeliveryStatusDescription || (DeliveryStatusDescription = {}));
// SUBSCRIPTION
var EventTypes;
(function (EventTypes) {
    EventTypes["INCOMING_MESSAGE"] = "INCOMING_MESSAGE";
    EventTypes["INCOMING_MESSAGE_SNIPPET"] = "INCOMING_MESSAGE_SNIPPET";
    EventTypes["OUTGOING_MESSAGE"] = "OUTGOING_MESSAGE";
    EventTypes["READ_UPDATE_CONVERSATION"] = "READ_UPDATE_CONVERSATION";
    EventTypes["DELETED_MESSAGE"] = "DELETED_MESSAGE";
    EventTypes["DELETED_CONVERSATION"] = "DELETED_CONVERSATION";
    EventTypes["DELIVERY_STATUS"] = "DELIVERY_STATUS";
})(EventTypes || (EventTypes = {}));

export { DeliveryStatusDescription, EventTypes, SortMode };
